module.exports = __webpack_public_path__ + "img/fixedAssetsMgt.12911899.svg";